import type {ListOfferTemplatesSearchInput} from "./list-offer-templates.schema";
import {useQuery} from "@tanstack/react-query";
import {listOfferTemplatesQueryOptions} from "./list-offer-templates.query-options";

export function useListOfferTemplates(rawInput: ListOfferTemplatesSearchInput) {
  return useQuery(listOfferTemplatesQueryOptions(rawInput));
}
